export const schemaMiPerfilUsuarioForm = {
  type: "object",
  properties: {
    name: {
      type: "string",
      title: "Nombre",
      description: "Ingresar nombres",
      minLength: 3,
    },
    surname: {
      type: "string",
      title: "Apellido",
      minLength: 3,
      description: "Ingresar apellidos",
    },
    username: {
      type: "string",
      title: "Usuario",
      minLength: 4,
      pattern: "^[^\\s]+$", 
      description: "El nombre de Usuario debe contener al menos cuatro caracteres y no puede tener espacios en blanco.",
    },
    password: {
      type: "string",
      title: "Nueva Contraseña",
      minLength: 6,
      pattern: "^[^\\s]+$", 
      description: "La contraseña debe contener al menos un caracter y no puede tener espacios en blanco.",
      maxLength:72,
      "ui:widget": "password" 
    },
    passwordCoincidencia: {
      type: "string",
      title: "Confirme la Contraseña",
      minLength: 6,
      pattern: "^[^\\s]+$", 
      description: "La contraseña debe contener al menos un caracter y no puede tener espacios en blanco.",
      maxLength:72
    },
    email: {
      type: "string",
      title: "Correo electrónico",
      description: "Ingrese correo electronico",
      format: "email",
    },

  },

  required: ["name", "surname", "username"],
};
